import { AccessabilitySection } from '../components/(sections)/accessability-section';
import { ArchiveSections } from '../components/(sections)/archive-section';
import { BasicDetailsSection } from '../components/(sections)/basic-details-section';
import { CategorySection } from '../components/(sections)/category-section';
import { ContactSection } from '../components/(sections)/contact-section';
import { ContentSection } from '../components/(sections)/content-section';
import { DigitalEventSection } from '../components/(sections)/digital-event-section';
import { EnvironmentDiplomaSection } from '../components/(sections)/environment-diploma-section';
import { EventPersonSection } from '../components/(sections)/event-person-section';
import { LocationSection } from '../components/(sections)/location-section';
import { OrganizerSection } from '../components/(sections)/organizer-section';
import { PreviewSection } from '../components/(sections)/preview-section';
import { StreamingSection } from '../components/(sections)/streaming-sections';
import { WebLinksSections } from '../components/(sections)/web-links-section';

export const sections = [
  {
    title: 'category',
    id: 'category-section',
    component: CategorySection,
  },
  {
    title: 'content',
    id: 'content-section',
    component: ContentSection,
  },
  {
    title: 'basic_details',
    id: 'basic-details-section',
    component: BasicDetailsSection,
  },
  {
    title: 'event_location',
    id: 'location-section',
    component: LocationSection,
  },
  {
    title: 'organizers',
    id: 'organizer-section',
    component: OrganizerSection,
  },
  {
    title: 'persons',
    id: 'persons-section',
    component: EventPersonSection,
  },
  {
    title: 'contact',
    id: 'contact-section',
    component: ContactSection,
  },
  {
    title: 'web-links',
    id: 'web-links-section',
    component: WebLinksSections,
  },
  {
    title: 'streaming',
    id: 'streaming-section',
    component: StreamingSection,
  },
  {
    title: 'digital_event',
    id: 'digital-event-section',
    component: DigitalEventSection,
  },
  {
    title: 'archive',
    id: 'archive-section',
    component: ArchiveSections,
  },

  {
    title: 'accessability',
    id: 'accessability-section',
    component: AccessabilitySection,
  },

  {
    title: 'environment_diploma',
    id: 'environment-diploma-section',
    component: EnvironmentDiplomaSection,
  },
  {
    title: 'preview_and_send',
    id: 'preview-and-send-section',
    component: PreviewSection,
  },
];
